import { FC, useContext, useState, type JSX } from 'react';
import { useLocation } from 'react-router';

import { Button, ButtonSizes, ButtonVariant, Icon, Link } from '@/shared/ui';

import { ROUTES } from '@/router/config';

import AuthContext from '@/contexts/Auth/AuthContext';

import { Drawer } from '../../Drawer/ui/Drawer';

import './DesktopMainMenuStyles.scss';

export const MobileSideMenu = (): JSX.Element => {
  const location = useLocation();
  const authContext = useContext(AuthContext);

  const [isDrawerOpen, setDrawerOpen] = useState(false);

  let pageContent;

  const toggleDrawer = (): void => {
    setDrawerOpen(!isDrawerOpen);
  };

  switch (location.pathname) {
    case ROUTES.HOME:
      pageContent = <HomePage toggleDrawer={toggleDrawer} />;
      break;
    default:
      pageContent = <AllPage toggleDrawer={toggleDrawer} />;
  }

  return (
    <div className="desktop-main-menu" id="main-menu">
      <Drawer
        isDrawerOpen={isDrawerOpen}
        toggleDrawer={(): void => toggleDrawer()}
        logoutHandler={(): void => {
          toggleDrawer();
          authContext.logout();
        }}
      />
      <div className="container desktop-main-menu__container">
        <div className="desktop-main-menu__links">{pageContent}</div>
        <Link to={ROUTES.HOME} className="desktop-main-menu__logo">
          <Icon name="evg_logo" color="white" width={96} height={32} />
        </Link>
      </div>
    </div>
  );
};

interface AllPageProps {
  toggleDrawer: () => void;
}

const AllPage: FC<AllPageProps> = ({ toggleDrawer }) => {
  return (
    <div className="desktop-main-menu__menu-button">
      <Button
        className="desktop-main-menu__button"
        variant={ButtonVariant.ICON_GHOST}
        size={ButtonSizes.SM}
        onClick={(): void => toggleDrawer()}
        aria-label="Open menu"
      >
        <Icon color="white" name="mobile_menu" />
      </Button>
    </div>
  );
};

const HomePage: FC<AllPageProps> = ({ toggleDrawer }): JSX.Element => {
  return <AllPage toggleDrawer={toggleDrawer} />;
};
